import * as auth from './auth';
import endpoints from './endpoints';
import * as features from './features';
import * as security from './security';

// Export other config modules
export { auth, endpoints, features, security };

// Increase package.json version to bump release notes
function getVersion() {
  const baseVersion = 10; // integer flag versioning ended at 12 while package.json was 12.
  const packageVersion = process.env.VUE_APP_VERSION;
  if (!packageVersion) return baseVersion;
  const [majorBit, minorBit, patchBit] = packageVersion.split('.');
  const major = Number.parseInt(majorBit, 10);
  const minor = Number.parseInt(minorBit, 10) / 1000;
  const patch = Number.parseInt(patchBit, 10) / 1e6;
  if (minor >= 1 || patch >= 0.001) {
    const version = packageVersion;
    throw new TypeError(`Frontend semver minor/patch "${version}" cannot be larger than 1000`);
  }
  const version = baseVersion + major + minor + patch;
  if (Number.isNaN(version)) {
    throw new TypeError(`Could not parse package version "${packageVersion}"`);
  }
  return +version.toFixed(6);
}
export const CURRENT_VERSION = getVersion();

// Set to true to force the maintenance mode
export const MAINTENANCE_MODE = false;

/* cSpell:disable */
export const GTAG_KEY = 'UA-41905116-3';
/* cSpell:enable */

// API Config
export const stage = process.env.VUE_APP_STAGE;

// Map keys
/* cSpell:disable */
export const mapAppId = 'leSZByvrtD6pggjARSfB';
export const mapAppCode = 'ZFQY0G58n0oOYeOkfaNKkg';

export const GOOGLE_MAPS_KEY = process.env.VUE_APP_GOOGLE_MAPS_KEY;

export const OPEN_WEATHER_MAP_KEY = process.env.VUE_APP_OPEN_WEATHER_MAP_KEY;
/* cSpell:enable */

// Store
export const STORE_MAX_UPDATE_FREQUENCY = 30000; // 30 seconds

// Xylem SSO
const xylemDomains = [
  'xylem.devicepilot.com',
];
export function isXylemSSO() {
  if (
    features.isEnabled(features.Features.FORCE_XYLEM_SSO)
    || features.isEnabled(features.Features.XYLEM)
  ) return true;
  return xylemDomains.includes(window.location.host);
}
